import { render, staticRenderFns } from "./home-transitoria.vue?vue&type=template&id=279ca680&scoped=true"
import script from "./home-transitoria.vue?vue&type=script&lang=ts"
export * from "./home-transitoria.vue?vue&type=script&lang=ts"
import style0 from "./home-transitoria.vue?vue&type=style&index=0&id=279ca680&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "279ca680",
  null
  
)

export default component.exports